
import { _replaceAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "featurePlatformCheckEnabled": true,
  "featureOktaLoginEnabled": true,
  "featureDevModeAvailable": false,
  "npasUrl": "",
  "siteId": "176",
  "baseUrl": "https://a2.vmedia.ca",
  "applicationName": "F-SENZATV",
  "basePath": "./",
  "appVersion": "1.0.61",
  "buildCounter": "11",
  "nuxt": {}
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    _replaceAppConfig(newModule.default)
  })
}

import cfg0 from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
